import { useMemo, useState, useCallback } from 'react';
import { TextField } from "@mui/material";
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

function Login(props) {
  const [text,changeText] = useState("");
  const [heading,changeHeading] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoggedin,changeLog] = useState(false);
  const [forgot,remember] = useState(false);

  var style1 = useMemo(()=>{
    return {
      margin:"auto",
      textAlign:"center",
      padding:"15px",
      backgroundColor:props.color,
      width:"fit-content",
      borderRadius:"5px"
    }
  },[props.color]);

  const handleClose = () => { 
    if(isLoggedin){
      setOpen(false); 
      window.location.replace("../home");
    }
    else setOpen(false);
  };

  var Authenticate = useCallback(()=>{
      let uname = document.getElementById("username").value,
      pass = document.getElementById("password").value;
      if(uname == ""){
        changeHeading("Username can't be Empty");
        changeText("Please Enter your Username");
        setOpen(true);
      }
      else if(pass == ""){
        changeHeading("Password can't be Empty");
        changeText("Please Enter your Password");
        setOpen(true);
      }
      else{
        let config = {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            "X-CSRFToken": props.csrf //TODO: Generate CSRF-Token
          },
          redirect: 'follow',
          referrerPolicy: 'no-referrer',
          body: JSON.stringify({
              username : uname,
              password : pass
          })};
          fetch("",config).then(res=>{
            changeHeading("Server Response CODE : "+res.status.toString());
            if(res.status === 200){
              res.json().then(data =>{ 
                if(data == "Login Successful") changeLog(true);
                if(data == "Invalid Credentials") remember(true);
                changeText(data);
                setOpen(true);
              }).catch(err => { 
                console.info(err); 
                changeText("Invalid Data Received from Server");
                setOpen(true);
              })
            }
            else{
              changeText(res.statusText);
              setOpen(true);
            }
          }).catch(err=>{
              console.info(err);
              changeHeading("Something is not right");
              changeText("There appears to be an error in the server");
              setOpen(true);
          });
      }
    },[props.csrf]);
  return (
    <>
        <h1 style={{margin:"auto",textAlign:"center"}}><u>Login to your Account</u></h1><br/>
        <div style={style1}>
            <TextField id="username" label="Enter Username" variant="outlined" type={"text"}
            sx={{ input: { color: props.textColor } }}
            InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
            <TextField id="password" label="Enter Password" variant="outlined" type={"password"}
            sx={{ input: { color: props.textColor } }}
            InputLabelProps={{ style: { color: props.textColor } }}/><br/><br/>
            <Button variant="contained" onClick={Authenticate}>Sign In</Button>
        </div>

        {/*Dialog-Box to display a message*/}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {heading}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {text}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {
              (forgot)?<Button component={Link} to="/changePass" onClick={()=>{
                 setOpen(false);
              }}>Forgot Password</Button>:null
            }
            <Button onClick={handleClose}>OK</Button>
          </DialogActions>
        </Dialog>
        <br/>
        <Link to="/signup" style={{textAlign:"center",display:"block",margin:"auto",color:"white"}}><b>No Account? Create one</b></Link>
    </>
  )
}

export default Login;